import http, { getTenantFromUrl } from "../helpers/http";

export const NewClient = async (payload, tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, message: "Client created successfully (Mock)", data: {} };
  }
  const response = await http().post("/up-secure/client", payload);
  return response.data;
};

export const ClientTrans = async (pageNumber, pageSize, tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, data: [], result: [], count: 0, totalPages: 0 };
  }
  const response = await http().get(`/up-secure/transaction?pageNumber=${pageNumber}&pageSize=${pageSize}`);
  return response.data;
};

export const TransactionId = async (id, tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, data: {}, result: {} };
  }
  const response = await http().get(`/up-secure/transaction/${id}`);
  return response.data;
};